import aboutProjectImg from "assets/img/nav/about-project.jpg";
import heroes from "assets/img/nav/heroes.jpg";
import history from "assets/img/nav/history.jpg";
import startJourney from "assets/img/nav/start-journey.jpg";
import team from "assets/img/nav/team.jpg";
import "assets/scss/Components/nav.scss";
import InteractiveContext from "context/InteractiveContext";
import i18next from "i18next";
import { useContext, useEffect, useState } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation } from "react-router-dom";
import { animated, config, useTransition } from "react-spring";

const TopNavbar = ({
  showMenuToggler,
  pageTitle,
  isBackgroundMusic,
  returnLink,
  setTutorialPage,
  tutorialPage,
}) => {
  const { t } = useTranslation();
  const backgroundImages = [
    startJourney,
    history,
    aboutProjectImg,
    heroes,
    team,
  ];

  const [index, setIndex] = useState(0);

  const fadingTextPropsTransition = useTransition(backgroundImages[index], {
    from: { opacity: 0 },
    to: { opacity: 1, scale: 1 },
    enter: { opacity: 1, scale: 1 },
    reset: true,
    config: config.molasses,
  });
  const { isMuted, toggleMuted } = useContext(InteractiveContext);
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const [audio] = useState(new Audio("/audio/background-audio2.mp3"));

  useEffect(() => {
    audio.loop = true;
    audio.muted = isMuted;
    isBackgroundMusic ? audio.play() : audio.pause();
  }, [audio, isBackgroundMusic, isMuted]);

  const location = useLocation();
  const [isStartPage, setIsStartPage] = useState(true);
  const [isScenePage, setIsScenePage] = useState(false);

  useEffect(() => {
    setIsStartPage(location.pathname === "/");
    setIsScenePage(location.pathname === "/scene");
  }, [location, setIsStartPage]);

  const changeLanguage = (e) => {
    i18next.changeLanguage(e.target.value);
  };

  const { resolvedLanguage } = i18next;

  const lngs = ["pl", "en"];

  return (
    <Navbar
      fixed="top"
      bg="dark"
      variant="dark"
      expand={false}
      className="mb-3"
      collapseOnSelect={true}
      expanded={expanded}
    >
      <Container fluid>
        <div className="z-100 d-flex flex-row z-index-10 position-relative">
          <Navbar.Toggle
            as={"div"}
            aria-controls={`offcanvasNavbar-expand-false`}
            className={`cursor-pointer border-0 ${
              showMenuToggler ? "" : "d-none"
            }`}
            onClick={toggleExpand}
          />
          {returnLink && (
            <Link
              className="ms-5 btn-white text-decoration-none d-flex justify-content-center align-items-center"
              to={returnLink.link}
            >
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.41848 1.02949L1.72406 7.54419L8.41847 14.0589"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
              <span className="ps-2">{t("Back")}</span>
            </Link>
          )}
        </div>
        <div className="position-absolute w-100 start-0 text-center">
          <span className="fs-14 text-uppercase user-select-none">
            {pageTitle}
          </span>
        </div>
        <div className="d-flex flex-row justify-content-center align-items-center z-index-10 position-relative">
          {isScenePage && (
            <div className="me-3">
              <span
                className="d-flex cursor-pointer me-4 btn-white"
                onClick={() => setTutorialPage(tutorialPage === 0 ? 1 : 0)}
              >
                {t("Instructions")}
              </span>
            </div>
          )}
          <div className="">
            <select
              id="language"
              className="d-flex transparent btn-white px-1 pe-3 py-0 cursor-pointer text-uppercase"
              onChange={changeLanguage}
              value={resolvedLanguage}
            >
              {lngs.map((lng) => {
                return (
                  <option
                    key={lng}
                    value={lng}
                    defaultValue={lng === resolvedLanguage}
                  >
                    {lng}
                  </option>
                );
              })}
            </select>
          </div>

          {!isStartPage && (
            <div className="ms-4">
              <div className="volumeBtn user-select-none ms-3">
                {isMuted && (
                  <svg
                    onClick={toggleMuted}
                    xmlns="http://www.w3.org/2000/svg"
                    width="33.195"
                    height="26"
                    viewBox="0 0 33.195 26"
                    className="btn-white"
                  >
                    <path
                      id="Path_15"
                      data-name="Path 15"
                      d="M22,7.756,27.244,13m0,0,5.244,5.244M27.244,13l5.244-5.244M27.244,13,22,18.244M1,9v8a2,2,0,0,0,2,2H8.18a2,2,0,0,1,1.414.585l4.9,4.9a1.77,1.77,0,0,0,3.021-1.252V2.77A1.77,1.77,0,0,0,14.5,1.518l-4.9,4.9A2,2,0,0,1,8.18,7H3A2,2,0,0,0,1,9Z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                )}
                {!isMuted && (
                  <svg
                    onClick={toggleMuted}
                    className="btn-white"
                    xmlns="http://www.w3.org/2000/svg"
                    width="30.673"
                    height="26"
                    viewBox="0 0 30.673 26"
                  >
                    <g
                      id="Group_3"
                      data-name="Group 3"
                      transform="translate(-4444 164)"
                    >
                      <path
                        id="Path_16"
                        data-name="Path 16"
                        d="M1,9v8a2,2,0,0,0,2,2H8.18a2,2,0,0,1,1.414.585l4.9,4.9a1.77,1.77,0,0,0,3.021-1.252V2.77A1.77,1.77,0,0,0,14.5,1.518l-4.9,4.9A2,2,0,0,1,8.18,7H3A2,2,0,0,0,1,9Z"
                        transform="translate(4444 -164)"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M15,8a5.625,5.625,0,0,1,0,9"
                        transform="translate(4451.875 -163.5)"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                      <path
                        id="Path_27"
                        data-name="Path 27"
                        d="M17.7,5a10.125,10.125,0,0,1,0,15.75"
                        transform="translate(4452.212 -163.875)"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                )}
              </div>
            </div>
          )}
        </div>

        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="start"
          className="d-flex flex-row w-100"
          backdrop="false"
        >
          <div className="d-flex flex-column offcanvas-content col-7">
            <Offcanvas.Body>
              <Offcanvas.Header
                className=""
                closeButton
                onClick={toggleExpand}
              />
              <p className={"fs-14 pb-3"}>Menu</p>
              <Nav
                bg="dark"
                variant="dark"
                className="justify-content-end flex-grow-1 pe-3 "
                onClick={toggleExpand}
              >
                <NavLink
                  to="/scene"
                  onMouseEnter={() => {
                    setIndex(0);
                  }}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <span className="text-uppercase">
                    {t("Start your Journey")}
                  </span>
                </NavLink>
                <NavLink
                  onMouseEnter={() => {
                    setIndex(1);
                  }}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/historia-mikolajowa"
                >
                  <span className="text-uppercase">
                    {t("The Story of Mikołajów")}
                  </span>
                </NavLink>
                <NavLink
                  onMouseEnter={() => {
                    setIndex(2);
                  }}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/o-projekcie"
                >
                  <span className="text-uppercase">
                    {t("About the Project")}
                  </span>
                </NavLink>
                <NavLink
                  onMouseEnter={() => {
                    setIndex(3);
                  }}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/bohaterowie"
                >
                  <span className="text-uppercase">{t("Interviewees")}</span>
                </NavLink>
                <NavLink
                  onMouseEnter={() => {
                    setIndex(4);
                  }}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/zespol"
                >
                  <span className="text-uppercase">{t("Team")}</span>
                </NavLink>
                {/* <NavLink
                    onMouseEnter={() => {
                      setIndex(1);
                    }}
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    to="/Paralax"
                  >
                    <span>Paralax</span>
                  </NavLink> */}
              </Nav>
              <div className="d-flex mt-5 pb-5">
                <a
                  target={"_blank"}
                  href="https://www.instagram.com/tarta_kolektyw/"
                  className="btn-white text-decoration-none me-3 fs-14 text-uppercase"
                  rel="noreferrer"
                >
                  INSTAGRAM
                </a>
                <a
                  target={"_blank"}
                  href="http://vnlab.filmschool.lodz.pl"
                  className="btn-white text-decoration-none mx-3 fs-14 text-uppercase"
                  rel="noreferrer"
                >
                  {t("vnLab page")}
                </a>
              </div>
            </Offcanvas.Body>
          </div>
          <div
            className="d-flex offcanvas-backdrop col-5 h-100"
            onClick={toggleExpand}
          >
            {fadingTextPropsTransition(({ opacity }, item) => {
              return (
                <animated.div
                  style={{ opacity }}
                  className={
                    "position-absolute col-5 start-0 h-100 d-flex justify-content-center align-items-center"
                  }
                >
                  <img src={item} alt="imageO" className="user-select-none" />
                </animated.div>
              );
            })}
          </div>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
